import React from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import cx from "classnames";

import routes from "../../../../routes";
import CircularProgress from "../CircularProgress";
import {
  StyledAlertDialog,
  StyledAlertDialogTitle,
  StyledCloseIcon,
  StyledAlertDialogContent,
  StyledAlertDialogActions,
  StyledAlertActionButtons,
  StyledAlertAgentActionButtons
} from "./styled";

export const Alert = ({
  type,
  details = "",
  handleClose,
  isOpen,
  handleConfirm,
  percentage = 0,
  progressLabel = "",
  isAgent = false
}) => {
  const navigate = useNavigate();

  const redirectToHome = () => {
    navigate(routes.quickapplyLanding);
    window.location.reload();
  };
  return (
    <StyledAlertDialog
      disableEscapeKeyDown
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="draggable-dialog-title"
      classes={{ paper: "paper" }}
    >
      <StyledAlertDialogTitle id="draggable-dialog-title">
        {type === "PROGRESS" ? (
          <CircularProgress percentage={percentage} label={progressLabel} />
        ) : (
          <StyledCloseIcon />
        )}
      </StyledAlertDialogTitle>
      {!!details && <StyledAlertDialogContent>{details}</StyledAlertDialogContent>}

      <div className="divider" />
      <StyledAlertDialogActions>
        {type === "PROGRESS" ? (
          <div className={cx("btnContainer", "ml0")}>
            <StyledAlertActionButtons
              onClick={handleConfirm}
              color="primary"
              variant="contained"
              className={"ml0"}
            >
              Yes
            </StyledAlertActionButtons>
          </div>
        ) : (
          <>
            {isAgent ? (
              <Grid item xs={12} className={"agentBtnContainer"}>
                <StyledAlertAgentActionButtons
                  onClick={handleConfirm}
                  color="primary"
                  variant="contained"
                >
                  Continue
                </StyledAlertAgentActionButtons>
              </Grid>
            ) : (
              <>
                <StyledAlertActionButtons
                  onClick={redirectToHome}
                  color="primary"
                  variant="outlined"
                >
                  No, Thanks
                </StyledAlertActionButtons>
                <StyledAlertActionButtons
                  onClick={handleConfirm}
                  color="primary"
                  variant="contained"
                >
                  Continue
                </StyledAlertActionButtons>
              </>
            )}
          </>
        )}
      </StyledAlertDialogActions>
    </StyledAlertDialog>
  );
};
